/* jshint esnext: true */
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.$el.on('click.ServicesToggle', (event) => {
            this.$document.trigger('toggleServices.Services');
        });
    }

    destroy() {
        this.$el.off('.ServicesToggle');
    }
}
